import fetchJsonp from 'fetch-jsonp';
import qs from 'qs';
import Risk from './risk';
export default class Group {
  /**
   * 获取当前用户的团信息，如果未开团，则返回null
   */
  static async info() {
    return fetchJsonp('https://page.aliyun.com/ambassador/groupBuy/create', {
      jsonpCallback: 'cback',
    })
      .then(res => res.json())
      .then(res => {
        if (res.code == 200) {
          return {
            userCode: res.data.userCode,
          };
        } else {
          return null;
        }
      });
  }
  /**
   * 参团校验
   * @param {stirng} groupCode 团Code
   */
  static async joinCheck(groupCode) {
    if (!groupCode) {
      return console.error('必须传递团Code');
    }
    const token = await Risk.getToken();
    const params = {
      umidToken: token.umidToken,
      collina: token.collina,
      buyCode: groupCode,
    };
    return fetchJsonp(`https://page.aliyun.com/ambassador/groupBuy/possible?${qs.stringify(params)}`)
      .then(res => res.json())
      .then(res => {
        if (res.code == 200) {
          return {
            status: true,
          };
        } else {
          return {
            status: false,
            errorCode: res.code,
            msg: res.msg,
          };
        }
      });
  }
  /**
   * 开团
   * @param {string} templateId 拼团活动ID
   */
  static async open(templateId) {
    if (!templateId) {
      return console.error('开团必须传递活动ID');
    }
    const token = await Risk.getToken();
    const params = {
      source: '5176.' + document.querySelector('body').dataset.spm,
      umidToken: token.umidToken,
      collina: token.collina,
      templateId: templateId,
    };
    return fetchJsonp(`https://page.aliyun.com/ambassador/groupBuy/create?${qs.stringify(params)}`)
      .then(res => res.json())
      .then(res => {
        if (res.code == 200) {
          return {
            status: true,
            data: {
              groupCode: res.data.buyCode,
            },
          };
        } else {
          return {
            status: false,
            errorCode: res.code,
            msg: res.msg,
          };
        }
      });
  }
  /**
   * 查询某个团的信息（不需要登录）
   * @param {string} groupCode 团Code
   */
  static async getGroupDetail(groupCode) {
    if (!groupCode) {
      return console.error('必须传递团ID');
    }
    const params = {
      buyCode: groupCode,
    };
    return fetchJsonp(`https://page.aliyun.com/ambassador/groupBuy/query?${qs.stringify(params)}`)
      .then(res => res.json())
      .then(res => {
        if (res.code == 200) {
          return res.data;
        } else {
          return null;
        }
      });
  }
  /**
   * 查询当前用户所有团信息，会返回两个字段，join和open
   * @param {string} templateId 拼团活动ID
   */
  static async getUserGroup(templateId) {
    if (!templateId) {
      return console.error('必须传递活动ID');
    }
    const params = {
      templateId: templateId,
    };
    return fetchJsonp(`https://page.aliyun.com/ambassador/groupBuy/queryByUser?${qs.stringify(params)}`)
      .then(res => res.json())
      .then(res => {
        if (res.code == 200) {
          const list = res.data || [];
          const open = list.find(item => item.leader == 1);
          return {
            open: open ? open.buyCode : null,
            join: null,
          };
        } else {
          return {
            join: null,
            open: null,
          };
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/components/group.js